import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { environment } from "src/environments/environment";
import { BranchCategoryModel } from "common/models/page-models/branch-category/branch-category-data.model";
import { FormDataService } from "../../base-data-services/form-data.service";


@Injectable({
    providedIn: 'root'
})
export class BranchCategoryFormDataService extends FormDataService<BranchCategoryModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.addBranchCategory, http, ss);
    }

    override getEditUrlAndMethod(id) {
        const edit = {
            url: environment.apiUrl + API_URL.getCategorydepartmentById,
            method: API_METHODS.post
        }
        return edit;
    }

      override getUpdatePayload(data) {
        let payload;
        payload = {
            id: data.id,
        };
        return payload;
    }

    createInstance(): BranchCategoryModel {
        return new BranchCategoryModel();
    }

    // override modifyAPIResponse(response: any) {
    //     return response['detail'][0];
    // }

    override getUpdateUrl() {
        return API_URL.updateBranchCategory;
    }

}

export { FormDataService };
